import Modal from "components/Modal";
import { useAppContext } from "contexts/AppContext";
import { ReactComponent as WarningIcon } from "assets/icons/warning.svg";

const GlobalErrorModal = () => {
  const { setGlobalError, globalError } = useAppContext();
  return (
    <Modal
      open={!!globalError}
      onClose={() => {
        setGlobalError(undefined);
        globalError?.onClose?.();
      }}
      lead="Erro"
      title={
        <>
          <WarningIcon />
          Ops, algo deu errado :(
        </>
      }
      description={
        globalError?.description ||
        "Estamos com algum problema em nossos sistemas e não conseguimos concluir sua solicitação. Por favor, tente de novo mais tarde."
      }
    />
  );
};

export default GlobalErrorModal;
